<template lang="pug">
svg(
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
)
  path(
    d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40H1.90476C0.852791 40 0 39.1472 0 38.0952V20Z"
    :fill="color"
  )
  image(
    v-if="base64Url"
    :href="base64Url"
    width="32"
    height="32"
    x="4"
    y="4"
  )
</template>

<script setup lang="ts">
export interface FcwServiceLogoMarkerProps {
  /**
   * The color of the service marker
   */
  color: string;
  /**
   * Url of the service logo
   */
  url: string;
}

const props = defineProps<FcwServiceLogoMarkerProps>();

// eslint-disable-next-line vue/no-setup-props-destructure
const base64Url = await toDataURL(props.url);

async function toDataURL(url: string): Promise<string> {
  if (!url) return '';
  const fileBlob = await (await fetch(url)).blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(String(reader.result));
    reader.onerror = reject;
    reader.readAsDataURL(fileBlob);
  });
}
</script>
